import React from "react";
import {
  Box,
  Flex,
  Heading,
  Text,
  Stack
} from "@chakra-ui/core";
import ScreenMockup from "../mockups/ScreenMockup"
import CallToAction from "../elements/CallToAction"
import CheckoutFormMockup from "../mockups/CheckoutFormMockup"


function LandingSectionFour() {
  return(
    <Box
    bg="warning.100"
    w="100%"
    py={["48px","60px","72px","76px"]}
  >
    <Flex maxW="1490px" flexWrap="wrap" m="auto" w="100%">
    <Box
        minWidth="340px"
        w={["100%", "100%", "100%", "50%"]}
        px="16px"
        m="auto"
        textAlign={["center","center","center","left"]}
      >
        <Box m="auto" w="100%" maxW="xl">
          <Heading
            as="h1"
            size="xl"
            lineHeight="shorter"
            fontWeight="bolder"
            color="primary.500"
          >
            Customized checkout form
          </Heading>

          <Text opacity="0.7" fontSize="lg" mt="2">
          Make your customer feel home by recognising your brand with customizable checkout. Add your logo, attach your invoice.
          </Text>
          <Stack m="auto" justifyContent={["center","center","center","flex-start"]} isInline my="12px">
          <CallToAction />
          </Stack>
        </Box>

      </Box>

    <Box
        pt={["30px", "40px", "50px", "0px"]}
        pb="20px"
        w={["100%", "100%", "100%", "50%"]}
      >
        <ScreenMockup 
          perspective ="translateZ(-1000px) perspective(2000px) rotateY(-15deg) rotateX(10deg)"  
          section="checkout" 
          size ="small" 
          >
            <CheckoutFormMockup />
          </ScreenMockup>
      </Box>

    </Flex>
  </Box>

  );  
}

export default LandingSectionFour;
